import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { SearchFiltersDropdown } from '../../components/search-filters-dropdown/search-filters-dropdown'

export const Make = withFacetContext(
    FacetName.make,
    withFilterContext(FilterName.make, SearchFiltersDropdown, {
        title: 'Make',
        onValueChanged: (values) => {
            return [values, [{ filter: FilterName.model, selected: [] }]]
        },
        renderFilterBar: true,
    })
)
